

// Column display configuration for ASN List

// export const ASN_STATUS_MAP = {
//   0: "New",
//   1: "Open",
//   2: "Loaded",
//   7: "Closed",
//   8: "On Hold",
//   9: "Shipped",
// };

// export const getAsnStatusLabel = (value) => {
//   if (value == null || value === "") return "";
//   const num = Number(value);
//   return ASN_STATUS_MAP[num] ?? String(value);
// };

// ✅ Comprehensive column display labels for all fields used in ASN list/tabs
export const columnLabels = {
  // Actions column
  "__actions": "",

  // ASN Details fields
  asnNumber: "ASN",
  AppointmentKey: "Appointment Key",
  owner: "Owner",
  asnType: "ASN Type",
  receiptStatus: "Status",
  createUsing: "Create Using",
  poNumber: "PO Number",
  externalASNReciept: "External ASN #",
  SKUID: "SKU ID",
  totalReceivedQty: "Received Qty",
  totalExpectedQty: "Total Expected Qty",
  totalExpectedWeight: "Total Expected Weight",
  totalExpectedCube: "Total Expected Cube",
  totalPOValue: "PO Invoice Value",
  grnNumber: "GRN",
  totalVolume: "Volume",
  totalWeight: "Weight",
  createdAt: "Created At",
  closedDate: "Closed Date",
  asnCreatedate: "Created Date",

  createdBy: "Created By",
  updatedAt: "Updated Date",
  updatedBy: "Updated By",

  // Supplier Address fields
  supplierName: "Supplier",
  supplierAddressLine1: "Supplier Address 1",
  supplierAddressLine2: "Supplier Address 2",
  supplierAddressLine3: "Supplier Address 3",
  supplierAddressLine4: "Supplier Address 4",
  supplierCity: "Supplier City",
  supplierState: "Supplier State",
  supplierCountry: "Supplier Country",
  supplierReference: "Supplier Ref",
  supplierContact: "Supplier Contact",
  supplierEmail: "Supplier Email",

  // Buyer Address fields
  buyerName: "Buyer",
  buyerAddressLine1: "Buyer Address 1",
  buyerAddressLine2: "Buyer Address 2",
  buyerAddressLine3: "Buyer Address 3",
  buyerAddressLine4: "Buyer Address 4",
  buyerCity: "Buyer City",
  buyerState: "Buyer State",
  buyerCountry: "Buyer Country",
  buyerReference: "Buyer Ref",
  buyerContact: "Buyer Contact",
  buyerEmail: "Buyer Email",

  // Carrier fields
  carrierName: "Carrier",
  carrierAddressLine1: "Carrier Address 1",
  carrierAddressLine2: "Carrier Address 2",
  carrierCity: "Carrier City",
  carrierState: "Carrier State",
  carrierCountry: "Carrier Country",
  carrierContact: "Carrier Contact",
  carrierEmail: "Carrier Email",

  // Load fields
  loadNumber: "Vehicle",
  truckDetails: "Vehicle Details",
  driverDetails: "Driver Details",
  actualDepartureDate: "Departure Date",
  expectedArrivalDate: "Expected Arrival",
  actualArrivalDate: "Actual Arrival",

  // Invoice fields
  invoiceNumber: "Invoice #",
  invoiceDate: "Invoice Date",
  invoiceType: "Invoice Type",
  invoiceAmount: "Invoice Amount",
  paymentTerms: "Payment Terms",
  invoiceUpload: "Invoice Upload",

  // User Defined fields
  udf1: "UDF 1",
  udf2: "UDF 2",
  udf3: "UDF 3",

  // Other common fields
  source: "Source",
  // lineItemsCount: "Items",
  status: "Status",
};

// ✅ Default visible fields (in desired display order)
export const defaultVisibleFieldsOLD = [
  // "__actions",
  "asnNumber",
  "owner",
  "grnNumber",
  "buyerName",
  "asnType",
  "receiptStatus",
  "supplierName",
  "actualDepartureDate",
  "externalASNReciept",
  "totalReceivedQty",
  "asnCreatedate",
  "source",
  "createdBy",
  "updatedAt",
  "updatedBy",
];


export const defaultVisibleFields = [
  "__actions",
  "asnNumber",
  "AppointmentKey",
  "owner",
  "supplierName",
  "asnType",
  "receiptStatus",
  "totalExpectedQty",
  "totalReceivedQty",
  "grnNumber",
  "carrierName",
  "loadNumber",
  "actualDepartureDate",
  "expectedArrivalDate",
  "asnCreatedate",
];


// Helper: per-column widths
// export const getColumnWidth = (fieldName) => {
//   const widthMap = {
//     __actions: 60,
//     asnNumber: 130,
//     lineItemsCount: 110,
//     receiptStatus: 120,
//     asnCreatedate: 160,
//     actualDepartureDate: 160,
//     expectedArrivalDate: 160,
//     invoiceNumber: 150,
//     invoiceAmount: 150,
//     carrierName: 160,
//     buyerName: 160,
//     supplierName: 160,
//     source: 120,
//     totalExpectedQty: 150,
//     totalReceivedQty: 150,
//     totalExpectedWeight: 150,
//     // Audit fields
//     createdBy: 160,
//     updatedAt: 160,
//     updatedBy: 160,
//   };

//   return widthMap[fieldName] || 160;
// };

// Value formatters for specific column types
export const getValueFormatter = (fieldName) => {
  switch (fieldName) {
    case "lineItemsCount1":
      return (params) =>
        params && params.value !== undefined ? `${params.value || 0} items` : "";
    case "invoiceAmount1":
      return (params) =>
        params && params.value
          ? `$${Number(params.value).toLocaleString(undefined, {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          })}`
          : "";
    case "totalExpectedQty1":
    case "totalReceivedQty1":
      return (params) =>
        params && params.value !== undefined
          ? Number(params.value || 0).toLocaleString()
          : "";
    default:
      return undefined;
  }
};

// Helper to compute header label
export const getColumnLabel = (field, startCaseFn) => {
  return columnLabels[field] || startCaseFn(field);
};
